import { useQuery } from "@tanstack/react-query";
import { getStudiosList } from "../api/getStudiosList";
import { queryClient } from "shared/api/queryClient";


export const useStudiosListQuery = () => {
  return useQuery({
    queryKey: ["studios"],
    queryFn: getStudiosList,
  });
};

export const invalidateStudiosListQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: ["studios"],
  });
};

